import { Observable } from 'rxjs';
import { FormConfig } from '../../config/base-form.config';
import { BaseEntityFilterComponent } from '../components/entity-filters/base-entity-filter.component';
import { BaseEntityRowComponent } from '../components/entity-list/base-entity-row.component';

export interface EntityTypeMetaData {
    title: string;
    entityName: string;
    apiUrl: string;
}

export interface GameEntityConfig {
    entityTypeMetaData: { [entityType: string]: EntityTypeMetaData };
    forms: { [entityType: string]: Observable<FormConfig> };
    entityFilters?: {
        [entityType: string]: typeof BaseEntityFilterComponent;
    };
    entityRowTemplates?: {
        [entityType: string]: typeof BaseEntityRowComponent;
    };
}

export abstract class EntityFormConfig {
    abstract games: { [gameId: string]: GameEntityConfig };
}
